import React, { useEffect } from "react";
import { useFormik } from "formik";
import '../../Login/LogInForm/loginform.scss';
import { Form, Row, Col, Button, Spinner } from 'react-bootstrap';
import * as Yup from "yup";
import { useState } from 'react';
import EyeIcon from '../../../assets/images/eye_icon.svg';
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { useMutation } from '@apollo/client';
import { REGISTER_USER } from '../../../gql/auth/mutation';
import { TERMSANDCONDITION, PRIVACYPOLICY } from '../../../configUrl';
function SignUpForm({ history }) {
    // Initialize a boolean state
    const [passwordShown, setPasswordShown] = useState(false);
    const [registerUser, { loading, error, data }] = useMutation(REGISTER_USER)

    useEffect(() => {
        const userToken = localStorage.getItem('token')
        const userRToken = localStorage.getItem('refreshtoken')
        const user = JSON.parse(localStorage.getItem('user'))
        if(userToken && userRToken && user){
            history.push('/dashboard')
        }
        // eslint-disable-next-line
    }, [])

    // Password toggle handler
    const togglePassword = () => {
        // When the handler is invoked
        // inverse the boolean state of passwordShown
        setPasswordShown(!passwordShown);
    };


    const formik = useFormik({
        initialValues: {
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: "",
            password: "",
            acceptedTerms: false
        },
        validationSchema: Yup.object({
            firstName: Yup.string()
                .required("First name is required")
                .matches(/[A-Za-z ]$/, "First name should contain characters only"),
            lastName: Yup.string()
                // .required("Last Name Required") 0-9.-
                .matches(/[A-Za-z ]$/, "Last name should contain characters only"),
            email: Yup.string()
                .email("Email should be valid")
                .required("Email is required")
                .matches(/^[a-zA-Z0-9._%+-]+@[a-z]+\.[a-z]{2,4}$/, "Email should be valid"),
            phoneNumber: Yup.string()
                .matches(/^[\d+ ]*$/, "Phone number should contain numbers only")
                // .matches(/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/, "Phone number should contain numbers only")
                // .matches(/^((\\+[1-9]{1,4})|(\\([0-9]{2,3}\\))|([0-9]{2,4}))*?[0-9]{3,4}?[0-9]{3,4}?$/, "Phone number should contain numbers only")
                .min(10, 'Phone number should have minimun 10 digits')
                .max(15, 'Phone number should not exceed 14 digits'),
            // selectPlan: Yup.string()
            //     .required("Select Plan"),
            password: Yup.string()
                .required("Password is required")
                .min(8, "Password is too short - should be 8 chars minimum.")
                .max(32, "Password should not exceed 32 characters.")
                .matches(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/, "Password must contain one uppercase letter, one lowercase letter, one number and one special character."),
            acceptedTerms: Yup.boolean()
                .oneOf([true], 'Please accept the Terms and Services & Privacy Policy.'),
        }),
        onSubmit: (values) => {
            const inputData = {
                firstName: values.firstName,
                lastName: values.lastName,
                email: values.email,
                password: values.password,
                mobile: values.phoneNumber.slice(0, 14),
                planType: 'TRIAL',
                // acceptedTerms: values.acceptedTerms,
            }
            try {
                registerUser({
                    variables: {
                        registerInput: inputData
                    }
                })
            }
            catch (e) {
                console.error(e)
            }
        }
    })

    if (data) {
        if(data?.registerUser){
            history.push('/sign-up-success')
        }
    }

    let errorMessage = '';
    if (error) {
        if (error.message) {
            errorMessage = error.message
        }
        if (!error.message) {
            errorMessage = "Something Went Wrong !"
        }
    }


    return (
        <Form className="logInForm" onSubmit={formik.handleSubmit}>
            {/*  */}
            <Row className="mb-4">
                <Form.Group as={Col} md="12" controlId="firstName">
                    <Form.Label>First Name *</Form.Label>
                    <Form.Control
                        name="firstName"
                        type="text"
                        placeholder="Enter your first name"
                        value={formik.values.firstName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={formik.errors.firstName && formik.touched.firstName && "error"}
                    />
                    {formik.errors.firstName && formik.touched.firstName && (
                        <div className="input-feedback">{formik.errors.firstName}</div>
                    )}
                </Form.Group>
            </Row> 
            <Row className="mb-4">
                <Form.Group as={Col} md="12" controlId="lastName">
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control
                        name="lastName"
                        type="text"
                        placeholder="Enter your last name"
                        value={formik.values.lastName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={formik.errors.lastName && formik.touched.lastName && "error"}
                    />
                    {formik.errors.lastName && formik.touched.lastName && (
                        <div className="input-feedback">{formik.errors.lastName}</div>
                    )}
                </Form.Group>
            </Row>

            {/*  */}
            <Row className="mb-4">
                <Form.Group as={Col} md="12" controlId="email">
                    <Form.Label>Email *</Form.Label>
                    <Form.Control
                        name="email"
                        type="text"
                        placeholder="Enter your email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={formik.errors.email && formik.touched.email && "error"}
                    />
                    {formik.errors.email && formik.touched.email && (
                        <div className="input-feedback">{formik.errors.email}</div>
                    )}
                </Form.Group>
            </Row>

            <Row className="mb-4">
                <Form.Group as={Col} md="12" controlId="phoneNumber">
                    <Form.Label>Phone Number (Optional)</Form.Label>
                    <Form.Control
                        name="phoneNumber"
                        type="text"
                        placeholder="Enter your phone number eg: +1 0123456789"
                        value={formik.values.phoneNumber.slice(0, 14)}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={formik.errors.phoneNumber && formik.touched.phoneNumber && "error"}
                    />
                    {formik.errors.phoneNumber && formik.touched.phoneNumber && (
                        <div className="input-feedback">{formik.errors.phoneNumber}</div>
                    )}
                </Form.Group>
            </Row>

            <Row className="mb-4">
                <Form.Group className="pwd-wrapper" as={Col} md="12" controlId="password">
                    <Form.Label>Password *</Form.Label>
                    <Form.Control
                        name="password"
                        type={passwordShown ? "text" : "password"}
                        placeholder="Atleast 8 characters"
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        // pattern="\S+" title="No Space Allowed"
                        className={formik.errors.password && formik.touched.password && "error"}
                    />
                    <span className={passwordShown ? "hide-pwd password-show" : "show-pwd password-show"} onClick={togglePassword}><img className="view-icon" src={EyeIcon} alt="view" /></span>
                    {formik.errors.password && formik.touched.password && (
                        <div className="input-feedback">{formik.errors.password}</div>
                    )}
                </Form.Group>
            </Row>
            {/* <Row className="mb-4">
                <Form.Group className="plan-selector" as={Col} md="12">
                    <Form.Label>Select Plan *</Form.Label>
                    <Form.Check
                        inline
                        disabled
                        label="Get Premium Now!"
                        name="selectPlan"
                        value="PAID"
                        checked={formik.values.selectPlan === "PAID"}
                        onChange={formik.handleChange}
                        type="radio"
                        id="paid"
                    />
                    <Form.Check
                        inline
                        label="Start 14 days Free Trial"
                        name="selectPlan"
                        value="TRIAL"
                        checked={formik.values.selectPlan === "TRIAL"}
                        onChange={formik.handleChange}
                        type="radio"
                        id="trial"
                    />
                    {formik.errors.selectPlan && formik.touched.selectPlan && (
                        <div className="input-feedback">{formik.errors.selectPlan}</div>
                    )}
                </Form.Group>
            </Row> */}
            <Row className="mb-4">
                <Form.Group className="terms-input" as={Col} md="12" controlId="acceptedTerms">
                    <Form.Control
                        type="checkbox"
                        name="acceptedTerms"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    />
                    <Form.Label>
                        I agree to the <Link to={{ pathname: TERMSANDCONDITION }} target="_blank">Terms and Services</Link>  and  <Link to={{ pathname: PRIVACYPOLICY }} target="_blank">Privacy Policy.</Link> *</Form.Label>

                    {formik.errors.acceptedTerms && formik.touched.acceptedTerms && (
                        <div className="input-feedback">{formik.errors.acceptedTerms}</div>
                    )}
                </Form.Group>
            </Row>
            {
                (loading && !error)  ?
                    <Button className='solid-button'>Sign Up
                        <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />
                    </Button>
                    :
                    <Button className='solid-button' type="submit" >Sign Up</Button>

            }
            {
                errorMessage && <p className="error">{errorMessage}</p>
            }
        </Form>
    )
}

export default withRouter(SignUpForm);
